import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { getAuthToken, isCategoriesApiUrl } from '../utils/auth.utils';
import { AccountRegistryService } from '../auth/services/account-registry.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const accountRegistry = inject(AccountRegistryService);

  if (isCategoriesApiUrl(req.url)) {
    const authToken = getAuthToken();

    if (authToken) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`)
      });

      return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            accountRegistry.markActiveExpired();
            localStorage.removeItem('auth_token');
            localStorage.removeItem('user_data');

            router.navigate(['/login']);
          }
          return throwError(() => error);
        })
      );
    }
  }

  return next(req);
};
